var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "GD001",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 256,
    y1: 98.598,
    x2: 256,
    y2: 413.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc5c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#f35e85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#d9659b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#b070bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a82fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 312,
    y1: 98.598,
    x2: 312,
    y2: 413.843,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-3",
    x1: 405.474,
    y1: 98.598,
    x2: 405.474,
    y2: 413.843,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-4",
    x1: 439.169,
    y1: 98.598,
    x2: 439.169,
    y2: 413.843,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-5",
    x1: 98.783,
    y1: 98.598,
    x2: 98.783,
    y2: 413.843,
    xlinkHref: "#New_Gradient_Swatch_2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M416,336a159.747,159.747,0,0,0-69.194-131.724l12.349-24.7a7.977,7.977,0,0,0,.83-3.578H360V160A104.181,104.181,0,0,0,280,58.8V16H264V56.305q-3.962-.3-8-.3t-8,.3V32H232V58.8A104.181,104.181,0,0,0,152,160v16h.015a7.977,7.977,0,0,0,.83,3.578l12.349,24.7A159.747,159.747,0,0,0,96,336a158.633,158.633,0,0,0,31.646,95.54,161.356,161.356,0,0,0,55.4,46.9,160.231,160.231,0,0,0,152.669-3.683A160.515,160.515,0,0,0,416,336Zm-16.323-9.6a55.973,55.973,0,0,1-31.494-80.672A143.117,143.117,0,0,1,399.677,326.4Zm-42.686-93.021c-.819,1.236-1.611,2.489-2.349,3.771a72.021,72.021,0,0,0,45.163,105.923,143.318,143.318,0,0,1-5.156,31.645A104,104,0,0,1,326.928,221.15c1.011-1.75,2.077-3.469,3.18-5.15h.948a16.132,16.132,0,0,0,3.84-.47A144.689,144.689,0,0,1,356.991,233.379ZM295.866,399.425A120.528,120.528,0,0,0,191.951,378.9l-17.765-52.146a120.531,120.531,0,0,0,69.725-79.674l54.013,10.674A120.541,120.541,0,0,0,332.1,358.021ZM172.944,184H339.057l-8,16H180.944Zm128.1,58.059-54.031-10.678A120.506,120.506,0,0,0,248,216h63.48A120.41,120.41,0,0,0,301.048,242.059ZM232,216A104.031,104.031,0,0,1,113.031,318.922a144.325,144.325,0,0,1,7.343-31.33A72.83,72.83,0,0,0,128,288a72.081,72.081,0,0,0,72-72Zm-57.976-88h50.989a32,32,0,1,0,0-16H182.28A87.976,87.976,0,0,1,344,160v8H168v-8A87.548,87.548,0,0,1,174.024,128ZM240,120a16,16,0,1,1,16,16A16.019,16.019,0,0,1,240,120Zm-62.9,95.53a16.132,16.132,0,0,0,3.84.47H184a56.064,56.064,0,0,1-56,56c-.335,0-.668-.019-1-.025,1.212-2.442,2.483-4.857,3.836-7.229A144.991,144.991,0,0,1,177.1,215.53ZM112,336c0-.353.015-.7.017-1.057A121.36,121.36,0,0,0,128,336a119.717,119.717,0,0,0,31.044-4.08l17.772,52.166a121.684,121.684,0,0,0-13.8,6.845A119.3,119.3,0,0,0,134.675,413.6,142.686,142.686,0,0,1,112,336Zm32.3,90.863a104,104,0,0,1,168.771,15.988,104.347,104.347,0,0,1,9.212,21,143.13,143.13,0,0,1-29.977,11.5,72.017,72.017,0,0,0-125.1-26.01A145.573,145.573,0,0,1,144.3,426.863ZM190.346,464.2c-3.4-1.742-6.717-3.632-9.965-5.644a56.2,56.2,0,0,1,14.63-12.2,56.023,56.023,0,0,1,81.564,32.152A144.5,144.5,0,0,1,256,480,142.432,142.432,0,0,1,190.346,464.2Zm146.02-8.711a120.727,120.727,0,0,0-28.47-45.515l36.264-41.44a121.789,121.789,0,0,0,12.831,8.534,119.742,119.742,0,0,0,32.443,12.892A144.569,144.569,0,0,1,336.366,455.49Z",
    style: {
      fill: "url(#New_Gradient_Swatch_2)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 136,
    width: 16,
    height: 16,
    style: {
      fill: "url(#New_Gradient_Swatch_2-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.126,475.654l9.748,12.688a191.556,191.556,0,0,0,74.948-144l-15.986-.684A175.591,175.591,0,0,1,363.126,475.654Z",
    style: {
      fill: "url(#New_Gradient_Swatch_2-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.822,327.658c-.239-5.57-.723-11.185-1.44-16.691l-15.866,2.066c.657,5.05,1.1,10.2,1.32,15.309Z",
    style: {
      fill: "url(#New_Gradient_Swatch_2-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.566,209.565l-11.132-11.493A190.463,190.463,0,0,0,64,336a193.849,193.849,0,0,0,2.893,33.382l15.76-2.764A177.745,177.745,0,0,1,80,336,174.59,174.59,0,0,1,133.566,209.565Z",
    style: {
      fill: "url(#New_Gradient_Swatch_2-5)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroid);
export default __webpack_public_path__ + "static/media/droid.de165dd887badb2bdbe9d97b8e527c6f.svg";
export { ForwardRef as ReactComponent };